import { render, staticRenderFns } from "./DecomDialog.vue?vue&type=template&id=8c0b7a66&"
import script from "./DecomDialog.vue?vue&type=script&lang=js&"
export * from "./DecomDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports